<template>
  <div class="raceDetails pa-3">
    <v-row no-gutters justify="center">
      <v-card id="cardTest">
        <v-card-title
          class="my-1 accent"
        >
          <v-icon>far fa-users</v-icon>
          <span
            depressed
            class="font-weight-bold text-left text-uppercase text-customizer-exp"
            v-html="$t('dashboard.menu.raceDetails.race_part_setup')"
            >{{ $t("dashboard.menu.raceDetails.race_part_setup") }}</span
          >
        </v-card-title>

        <RaceParticipant />
      </v-card>
    </v-row>
  </div>
</template>

<script>
import RaceParticipant from "@/components/dashboard/raceDetails/RaceParticipant.vue";

export default {
  components: {
    RaceParticipant
  }
}
</script>